import React from 'react';
import 'react-dropdown/style.css';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Auth } from 'aws-amplify';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';
import * as moment from 'moment';
import { getConsumerUser, getBusinessUserAffilate } from '../../../Actions/actions';
import SideMenu from '../../sideMenu/sideMenu';
import * as envKeys from '../../../ENV';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: '',
      subscriptionType: '',
      dateOfJoining: '',
      ifactive: '',
      affilateUrl: '',
      businessName: '',
      position: '',
      settlementUserIdAffiliateData1: [],
      UserName: '',


    };
    // this.onChange = this.onChange.bind(this);
  }


  componentDidMount() {
    const id = this.props.match.params.referralId;
    const roleName = this.props.match.params.roleName;
    if (roleName === 'Business-User') {
      this.props.getBusinessUserAffilate(id);
    } else {
      this.props.getConsumerUser(id);
    }
    // Auth.currentUserInfo().then((res) => {
    //   const Fname = res.attributes['custom:first_name'];
    //   const Lname = res.attributes['custom:last_name'];
    //   const name = `${Fname} ${Lname}`;

    //   this.setState({ UserName: name });
    // }).catch(error => error);
  }

  componentDidUpdate() {
    const { BusinessUserProfileDataAffilate, ConsumerUserData } = this.props.data;
    const { settlementUserIdAffiliateData1 } = this.state;
    const roleName = this.props.match.params.roleName;
    if (roleName === 'Business-User') {
      if (settlementUserIdAffiliateData1 !== BusinessUserProfileDataAffilate) {
        this.setState({
          firstName: BusinessUserProfileDataAffilate.firstName,
          lastName: BusinessUserProfileDataAffilate.lastName,
          email: BusinessUserProfileDataAffilate.email,
          userType: BusinessUserProfileDataAffilate.roleName,

          subscriptionType: BusinessUserProfileDataAffilate.planName,
          dateOfJoining: BusinessUserProfileDataAffilate.createdAt,
          ifactive: 'active',
          affilateUrl: `${envKeys.REACT_APP_FRONTEND_URL}/signup/${BusinessUserProfileDataAffilate.affiliateKey}`,
          businessName: BusinessUserProfileDataAffilate.companyName,
          position: BusinessUserProfileDataAffilate.companyTitle,
          settlementUserIdAffiliateData1: BusinessUserProfileDataAffilate,
        });
      }
    } else if (settlementUserIdAffiliateData1 !== ConsumerUserData) {
      this.setState({
        firstName: ConsumerUserData.firstName,
        lastName: ConsumerUserData.lastName,
        email: ConsumerUserData.email,
        userType: ConsumerUserData.roleName,

        subscriptionType: ConsumerUserData.planName,
        dateOfJoining: ConsumerUserData.createdAt,
        ifactive: 'active',
        affilateUrl: `${envKeys.REACT_APP_FRONTEND_URL}/signup/${ConsumerUserData.affiliateKey}`,
        businessName: BusinessUserProfileDataAffilate.companyName,
        position: BusinessUserProfileDataAffilate.companyTitle,
        settlementUserIdAffiliateData1: ConsumerUserData,
      });
    }
  }


  render() {
    const {
      settlementUserIdAffiliateData1, dateOfJoining, businessName, position, affilateUrl, ifactive, subscriptionType, firstName, lastName, email, userType, UserName,
    } = this.state;
    const userDtoInfo = [];
    if (settlementUserIdAffiliateData1 !== undefined) {
      if (settlementUserIdAffiliateData1.userDto !== undefined) {
        settlementUserIdAffiliateData1.userDto.map((item, index) => {
          userDtoInfo.push(
            <span key={`s${index}`}>

              <div className="vehicle-fields affiliate-referral-list">
                <div className="form-id">
                  {item.userId}
                </div>
                <div className="form-name">
                  {item.firstName}
                </div>
                <div className="form-category">
                  {item.lastName}
                </div>

                <div className="form-type">
                  {item.roleName}
                </div>
                <div className="form-created">
                  {item.email}
                </div>

              </div>


            </span>,
          );
          return true;
        });
      }
    }

    return (
      <span>

       welcome
        <SideMenu userName={UserName} />
        <div className="container">
          <div className="main-content bg-grey">

            <div className="section-content dashboard">
              <div className="row">

                <div className="dashboard-tabs">
                  <div className="row ">
                    <div className="">
                      <div className="section-content partner-dashboard partner-referral parnter-settlement-detail-view">
                        <div className="row">
                          <div className="col s12 referral-hdr">
                            <h4 className="col s12 m9">User Details</h4>
                          </div>

                          <div id="AllSettlemnet" className="referral-data col s12 tab-data active">
                            <div className="col s12">

                              <div className="settlement-grid">
                                <div className="settlement-gridrefereal">
                                  <div className="grid-outer div-full">
                                    <div className="settlement-detailstop settlement-referalkdetails">
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>First Name: </b>
                                          <span className="settlement-detialcontent-name">{firstName}</span>
                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent ">
                                        <p>
                                          <b>Last Name: </b>
                                          <span className="settlement-detialcontent-name">
                                            {' '}
                                            {lastName}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col s6 settlement-detialcontent">
                                        <p>
                                          <b>Email Id: </b>
                                          <p>{email}</p>
                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>User Type: </b>
                                          <span>{userType}</span>
                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>Subscription Type: </b>
                                          <span>{subscriptionType}</span>
                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>Date of joining: </b>
                                          <span>
                                            {moment(dateOfJoining).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(dateOfJoining).format('MM-DD-YYYY')}
                                          </span>

                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>If active: </b>
                                          <span>{ifactive}</span>
                                        </p>
                                      </div>
                                      <div className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>Referral url: </b>
                                          <p>{affilateUrl}</p>
                                        </p>
                                      </div>
                                      <div style={{ display: (userType === 'Consumer') ? 'none' : 'inline-block' }} className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>Business Name: </b>
                                          <span>{businessName}</span>
                                        </p>
                                      </div>
                                      <div style={{ display: (userType === 'Consumer') ? 'none' : 'inline-block' }} className="col s6  settlement-detialcontent">
                                        <p>
                                          <b>Position: </b>
                                          <span>{position}</span>
                                        </p>
                                      </div>

                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>


          </div>


        </div>
      </span>
    );
  }
}

Profile.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  data: state.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getConsumerUser, getBusinessUserAffilate }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(Profile));
